var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mb_32 text_dark"},[_vm._v(" Счета и акты ")]),_c('mp-tabs',{staticClass:"mb_32",attrs:{"tabs":_vm.tabs},on:{"changeTab":_vm.changeTab}}),_c('keep-alive',[_c(_vm.component,{tag:"component",attrs:{"component":_vm.component}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }